import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=ceb52430&"
import script from "./NewsAdd.vue?vue&type=script&lang=js&"
export * from "./NewsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports